import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "props-table px-4" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_render_vnode = _resolveComponent("render-vnode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.finalProps, (value, key) => {
      return (_openBlock(), _createElementBlock("div", {
        id: `item-${key}`,
        key: key,
        class: _normalizeClass([{ 'no-text': !value.text }, "prop-item"])
      }, [
        (value.text)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(value.text), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(`prop-component component-${value.component}`)
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(value.component), _mergeProps({
            [(value.valueProp) || ""]: value.value
          }, value.extraProps, _toHandlers(value.events)), {
            default: _withCtx(() => [
              (value.options)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(value.options, (option, k) => {
                    return (_openBlock(), _createBlock(_resolveDynamicComponent(value.subComponent), {
                      key: k,
                      value: option.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_render_vnode, {
                          "v-node": option.text
                        }, null, 8, ["v-node"])
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1040))
        ], 2)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}